









// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux';

@Component({
  name: 'EditBaseFlux',    
  components:{EditDrawer},
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseFlux extends Vue {
  
  private original = getDefaultAloFlux()
  private modified = getDefaultAloFlux()
  private showDrawer = false
  private saving = false 

  edit(item:AloFlux) {        
    this.$store.myActions.ADM_FLUX_RESET_STATUS()
    this.showDrawer = true
    this.original = item
    this.modified = cloneDeep(item) 

    return this.modified   
  }  

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get fluxStatus() {
    return this.$store.myGetters.fluxStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_FLUX_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.fluxStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

  
}
